import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BankCodes } from "../../models/polymer/BankCodes.model";
import { BASEURL_POLYMER, SUB_PATH_BASIC } from "../../utils/api";

interface QueryParams {
  singpass_token: string;
}

export const bankCodesApi = createApi({
  reducerPath: "bankCodesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASEURL_POLYMER,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Access-Control-Request-Method", "GET");
      headers.set("X-Content-Type-Options", "nosniff");
    },
  }),
  endpoints: (builder) => ({
    getBankCodes: builder.query<BankCodes, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url: `${SUB_PATH_BASIC}/bank-codes`,
        headers: {
          Authorization: `Bearer ${queryParams.singpass_token}`,
        },
      }),
      keepUnusedDataFor: 1,
      transformResponse: (query: BankCodes, meta: any) => {
        console.log("transformResponse ran")
        return query;
      },
    }),
  }),
});

export const { useGetBankCodesQuery } = bankCodesApi;
